import React from 'react';
import PropTypes from 'prop-types';

import generalStyles from './style/general.css';

export default function CardImage({ image }) {
  const style = { backgroundImage: `url("${image}")` };
  return <div className={generalStyles.cover} style={style} />;
}

CardImage.propTypes = {
  image: PropTypes.string,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardImage/index.js